module.exports = __webpack_public_path__ + "static/img/banner3.8b0c666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clinic/banner3.png
// module id = g2hV
// module chunks = 1